import React from "react";
import "../MenuLeftProveedorComercializadorLealtad/menuLeftProvLealtad.css";
//
import logoAmebo from "../../../Lealtad/assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaFileArchive, FaArchive, FaUserAlt, FaUserCog } from "react-icons/fa";
import { FaDeleteLeft, FaUserTie } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import { ImProfile } from "react-icons/im";
import { LuClipboardList } from "react-icons/lu";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuLeftAdminLealtad = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="allmenuleftlealtad">
      <div className="boxlogoprovlealtad">
        <img className="logomenuleftprovlealtad" src={logoAmebo} alt="logo" />
      </div>
      <div className="boxallbuttonprovlealtad">
        <Link to="/portal-admin-proveedor-lealtad/todas-las-ventas">
          <div className="boxbuttonprovlealtad">
            <p className="letterbuttonprovlealtad">
              <MdOutlineAttachMoney className="iconprovlealtad" />
              Ventas
            </p>
          </div>
        </Link>

        <Link to="/portal-admin-proveedor-lealtad/lista-comercializadores">
          <div className="boxbuttonprovlealtad">
            <p className="letterbuttonprovlealtad">
              <FaUserCog className="iconprovlealtad" />
              Comercializadores
            </p>
          </div>
        </Link>

        <Link to="/portal-admin-proveedor-lealtad/lista-proveedores">
          <div className="boxbuttonprovlealtad">
            <p className="letterbuttonprovlealtad">
              <FaUserCog className="iconprovlealtad" />
              Proveedores
            </p>
          </div>
        </Link>

        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "Perfil")}
        >
          <p className="letterbuttonprovlealtad">
            <FaUserAlt className="iconprovlealtad" />
            Perfil
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "ExcelComer")}
        >
          <p className="letterbuttonprovlealtad">
            <ImProfile className="iconprovlealtad" />
            Alta comercializador
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "ExcelProv")}
        >
          <p className="letterbuttonprovlealtad">
            <FaUserTie className="iconprovlealtad" />
            Alta proveedores
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "ExcelSales")}
        >
          <p className="letterbuttonprovlealtad">
            <FaFileArchive className="iconprovlealtad" />
            Alta ventas
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "ListProveedordescarga")}
        >
          <p className="letterbuttonprovlealtad">
            <LuClipboardList className="iconprovlealtad" />
            Descargar ventas
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "xmldowload")}
        >
          <p className="letterbuttonprovlealtad">
            <FaArchive className="iconprovlealtad" />
            Descarga proveedor
          </p>
        </div>
        <div
          className="boxbuttonprovlealtad"
          onClick={(e) => changeviewprov(e, "Contraseña")}
        >
          <p className="letterbuttonprovlealtad">
            <RiLockPasswordFill className="iconprovlealtad" />
            Cambiar contraseña
          </p>
        </div>
        <div className="boxbuttonprovlealtad" onClick={handleLogout}>
          <p className="letterbuttonprovlealtad">
            <FaDeleteLeft className="iconprovlealtad" />
            Salir
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuLeftAdminLealtad;
